import { Box, Button, useTheme } from '@mui/material';
import { FiPlus } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const NoPosts = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 10 },
        visible: { opacity: 1, y: 0 }
    };

    const features = [
        { icon: '💰', text: t('dashboard.subscriptions.featureRecurringRevenue'), description: t('dashboard.subscriptions.featureRecurringRevenueDesc') },
        { icon: '📅', text: t('dashboard.subscriptions.featureScheduleContent'), description: t('dashboard.subscriptions.featureScheduleContentDesc') },
        { icon: '🎯', text: t('dashboard.subscriptions.featureTierAccess'), description: t('dashboard.subscriptions.featureTierAccessDesc') },
        { icon: '🎥', text: t('dashboard.subscriptions.featureMultipleFormats'), description: t('dashboard.subscriptions.featureMultipleFormatsDesc') },
        { icon: '💎', text: t('dashboard.subscriptions.featureOneTimePurchase'), description: t('dashboard.subscriptions.featureOneTimePurchase') },
        { icon: '🔒', text: t('dashboard.subscriptions.featurePrivateContent'), description: t('dashboard.subscriptions.featurePrivateContentDesc') },
        { icon: '📊', text: t('dashboard.subscriptions.featureContentAnalytics'), description: t('dashboard.subscriptions.featureContentAnalyticsDesc') }
    ];

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            variants={containerVariants}
            style={{
                backgroundColor: '#fff',
                border: '1px solid #E4EBF6',
                borderRadius: '16px',
                padding: props.windowWidth > 900 ? '40px 0px' : '20px 0px',
                margin: props.windowWidth > 900 ? '0px 0' : '20px',
                // boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden'
            }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: props.windowWidth > 900 ? '40px 20px' : '40px 20px',
                    textAlign: "center",
                    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(247,249,252,0.4) 100%)',
                }}
            >
                <motion.div
                    variants={itemVariants}
                    style={{
                        padding: props.windowWidth > 900 ? '24px 24px' : '0px 0px',
                        textAlign: 'center',
                        borderRadius: '12px',
                        maxWidth: '650px'
                    }}>
                    <motion.div
                        initial={{ scale: 0.5, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        style={{
                            fontSize: '56px',
                            marginBottom: '16px',
                            filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
                        }}>
                        📂
                        {/* ✍️ */}
                    </motion.div>
                    
                    <motion.h2
                        variants={itemVariants}
                        style={{
                            margin: '0',
                            fontSize: '24px',
                            fontWeight: '700',
                            color: '#1D1D1D',
                            fontFamily: 'Roboto, sans-serif',
                            marginBottom: '12px',
                            letterSpacing: '-0.5px'
                        }}>
                        {t('dashboard.subscriptions.readyToSharePost')}
                    </motion.h2>
                    
                    <motion.p
                        variants={itemVariants}
                        style={{
                            fontSize: '16px',
                            color: '#6E7787',
                            fontWeight: '400',
                            textAlign: 'center',
                            margin: '0 auto 20px',
                            maxWidth: '500px',
                            fontFamily: 'Roboto, sans-serif',
                            lineHeight: '1.6'
                        }}>
                        {t('dashboard.subscriptions.startBuildingDesc')}
                    </motion.p>

                    <motion.div
                        variants={itemVariants}
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px',
                            justifyContent: 'center',
                            marginBottom: '40px'
                        }}>
                        {features.map((feature, index) => (
                            <motion.div
                                key={index}
                                // whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '6px 14px',
                                    backgroundColor: '#F5F9FF',
                                    borderRadius: '100px',
                                    border: '1px solid #E4EBF6',
                                    transition: 'all 0.2s ease'
                                }}>
                                <div style={{ 
                                    fontSize: props.windowWidth > 900 ? '14px' : '12px', 
                                    marginRight: '8px',
                                    color: 'var(--brand-color)'
                                }}>{feature.icon}</div>
                                <span style={{
                                    fontSize: props.windowWidth > 900 ? '12px' : '10px',
                                    fontWeight: '500',
                                    color: '#1D1D1D'
                                }}>{feature.text}</span>
                            </motion.div>
                        ))}
                    </motion.div>

                    <motion.div
                        variants={itemVariants}
                        // whileHover={{ scale: 1.02 }}
                        // whileTap={{ scale: 0.98 }}
                        >
                        <Button
                            disableElevation
                            disabled={props.disabled}
                            sx={{
                                backgroundColor: props.disabled ? '#E0E0E0' : 'var(--brand-color)',
                                color: props.disabled ? '#9E9E9E' : 'white',
                                fontSize: '16px',
                                fontWeight: '600',
                                width: '100%',
                                maxWidth: '300px',
                                height: '60px',
                                margin: '0 auto 60px auto',
                                borderRadius: '100px',
                                textTransform: 'none',
                                cursor: props.disabled ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                ':hover': {
                                    backgroundColor: props.disabled ? '#E0E0E0' : 'var(--brand-color)',
                                    transform: props.disabled ? 'none' : 'translateY(-1px)',
                                }
                            }}
                            onClick={() => { 
                                if (!props.disabled) {
                                    props.buttonAction() 
                                }
                            }}
                            variant='contained'
                        >
                            <FiPlus style={{ marginRight: '8px', color: props.disabled ? '#9E9E9E' : '#fff', strokeWidth: '2.5', fontSize: '20px' }} />
                            {props.disabled ? t('checkout.subscriptionRequired') : t('dashboard.subscriptions.createFirstPost')}
                        </Button>
                    </motion.div>

                    <motion.p
                        variants={itemVariants}
                        style={{
                            fontSize: '14px',
                            color: '#6E7787',
                            fontWeight: '400',
                            textAlign: 'center',
                            margin: '0',
                            fontFamily: 'Roboto, sans-serif'
                        }}>
                        {t('dashboard.subscriptions.needInspiration')}{' '}
                        <a
                            href={'https://help.withme.so/en/articles/6988667-decide-on-the-content-for-your-membership'}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: '#3B55F3',
                                textDecoration: 'none',
                                fontWeight: '500',
                                transition: 'all 0.2s ease',
                                ':hover': {
                                    textDecoration: 'underline'
                                }
                            }}>
                            {t('dashboard.subscriptions.contentCreationGuide')}
                        </a>
                    </motion.p>
                </motion.div>
            </Box>
        </motion.div>
    );
};

export default NoPosts;
